<template>
    <div>
        <center>
            <h3>Validasi Whatsapp</h3>
        </center>
        <br>
        <form v-on:submit.prevent="validateWhatsapp">
            <label for="">Pilih Kontak / Group*</label>
            <multiselect v-model="multiselect.value" tag-placeholder="Cari group atau kontak"
                    placeholder="Cari group atau kontak" label="label" track-by="id" :options="multiselect.options"
                    :multiple="true" :internal-search="false" :loading="multiselect.isLoading"
                    @search-change="loadReceiver" ref="selectedItems">
                    <template slot="beforeList">
                        <div>
                            <label @click="selectNone" class="selectAll">Deselect All</label>
                            <label @click="selectAll" class="selectAll">Select All</label>
                        </div>
                    </template>
                </multiselect>            
                <br />
            <p>
                Pilih kontak / group yang akan divalidasi. Jika tidak dipilih semua kontak akan divalidasi.
            </p>
            <br />
            <label>Device</label>
            <select v-model="form.device" class="form-control" required>
                <option :value="null_value" selected disabled>
                    == PILIH DEVICE ==
                </option>
                <option v-for="option in devices" :key="option.id" :value="option.id">{{ option.name }}
                    ({{ option.status }})</option>
            </select>
            <br />
            <div class="alert alert-warning" role="alert">
            Proses validasi akan berjalan di latar belakang. Silakan periksa status secara berkala.<br><br>
            Mohon diperhatikan, pengecekan nomor sekaligus dapat meningkatkan risiko pemblokiran (banned) dan menjadi tanggung jawab pengguna.
            </div>
            <button class="btn btn-primary btn-block" :disabled="isLoading">
                <span v-if="isLoading">
                    <div class="spinner-border spinner" role="status"></div>
                    Sedang memproses...
                </span>
                <span v-else>
                    Submit
                </span>
            </button>

        </form>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect
        },
        props: ["devices"],
        data() {
            return {
                importData: [],
                form: {
                    name: "",
                    number: "",
                    variable: [],
                    device: null,
                },
                isLoading: false,
                multiselect: {
                    value: [],
                    options: [],
                    isLoading: false
                }
            };
        },
        mounted() {
            this.getBlastList(1)
            this.loadDevice()
        },
        methods: {
            async getBlastList(limit, search = null) {
                this.multiselect.isLoading = true
                this.multiselect.options = []
                let option = []
                //let res = await this.$store.dispatch("contact_blast_list", {});
                let contact = await this.$store.dispatch("contact_list", {
                    columnFilters: {
                        name: search
                    },
                    page: 1,
                    limit: 100
                })
                let group = await this.$store.dispatch("group_list", {
                    columnFilters: {
                        name: search
                    },
                    page: 1,
                    limit: 500
                })

                contact = contact.data.data.contacts
                group = group.data.data.groups

                this.contact = contact
                this.group = group

                for (let i = 0; i < group.length; i++) {
                    option.push({
                        id: "g-" + group[i].id,
                        number: "",
                        label: "[GROUP] " + group[i].name
                    })
                }

                for (let i = 0; i < contact.length; i++) {
                    option.push({
                        id: "c-" + contact[i].id,
                        number: contact[i].number,
                        is_valid: contact[i].status,
                        label: "[CONTACT] " + contact[i].name + " (" + contact[i].number + ")"
                    })
                }
                
                this.multiselect.options = option
                this.multiselect.isLoading = false
            },
            loadReceiver(query) {
                this.getBlastList(100, query)
            },
            selectNone() {
                this.multiselect.value = [];
                this.$refs.selectedItems.deactivate();
            },
            selectAll() {
                this.multiselect.value = this.multiselect.options;
                this.$refs.selectedItems.deactivate();
            },
            selectNoneGrup() {
                this.multiselect.value = [];
                this.$refs.selectedItemsGrup.deactivate();
            },
            selectAllGrup() {
                this.multiselect.value = this.deviceGroups
                this.$refs.selectedItemsGrup.deactivate();
            },
            async loadDevice() {
                let response = await this.$store.dispatch("device_list")
                this.devices = response.data.data.devices
            },
            async readFile() {
                let file = event.target.files[0];
                if (file.type != "text/csv") {
                    this.$toast.error("File harus .csv")
                    return
                }

                this.importData = []
                this.csvImportReady = false
                this.csvParseLoading = true

                try {
                    let result = await this.papaParseAsync(file);
                    await this.arrayToData(result)

                    if (this.importData.length != 0) this.csvImportReady = true
                } catch (err) {
                    this.$toast.error(err);
                }
                this.csvParseLoading = false
            },
            arrayToData(array) {
                for (let i = 1; i < array.length; i++) {
                    this.importData.push({
                        request: array[i][0],
                        text: array[i][1],
                        file: array[i][2],
                        data: array[i][3],
                        message_type: array[i][4],
                        hold: parseInt(array[i][5]),
                        sensitive: parseInt(array[i][6]),
                    })
                }
            },
            papaParseAsync(file) {
                return new Promise((resolve, reject) => {
                    this.$papa.parse(file, {
                        header: false,
                        complete(results) {
                            resolve(results.data)
                        },
                        error(err, ) {
                            reject(err)
                        }
                    })
                })
            },
            async validateWhatsapp() {
                //check value of multiselect
                if (this.multiselect.value.length == 0) {
                    this.$toast.error("Pilih kontak / group yang akan divalidasi");
                    return
                }

                if(!this.form.device) {
                    this.$toast.error("Pilih device yang akan digunakan");
                    return
                }

                //check value of device
                this.isLoading = true
                    try {
                        let number = []
                        let selected = this.multiselect.value

                        for (let i = 0; i < selected.length; i++) {
                            let split = selected[i].id.split("-")
                            let n = selected[i].number
                            let is_valid = selected[i].is_valid
                            let selector
                            

                            if (split[0] == "g") {
                                selector = "group"
                            } else {
                                selector = "contact"
                                if(is_valid != null) {
                                    continue
                                }
                            }

                            let res

                            if (selector == "group") {
                                res = await this.$store.dispatch("group_list_member", {
                                    group_id: split[1],
                                });

                                //add if status == null remove
                                res = res.data.data.members.filter(item => item.status == null) ?? []

                                if(res.length != 0) {
                                    //map res to number
                                    res = res.map(item => item.number)
                                }
                            } else {
                                res = [n]
                            }

                            for (let j = 0; j < res.length; j++) {
                                if (!res[j]) {
                                    continue
                                }

                                //dont push duplicate number
                                if (number.includes(res[j])) {
                                    continue
                                }

                                number.push(res[j])
                            }
                        }

                        this.$toast.success("Proses validasi whatsapp sedang berjalan di latar belakang. Silakan tunggu...");
                        let response = await this.$store.dispatch("contact_validate_whatsapp", {
                            device_id: parseInt(this.form.device),
                            data: number
                        });
                        this.$toast.success(response.data.message);
                        this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }finally {
                    this.isLoading = false
                    this.$root.$emit("toggle_modal", "validasi_whatsapp")
                    this.$root.$emit("refresh_table", true)
                }
            },
        },
    };
</script>

<style scoped>
    .spinner {
        height: 1rem !important;
        width: 1rem !important;
    }

    .btn-spinner {
        line-height: 1rem !important;
    }
</style>

<style scoped>
    .thick-border {
        border: 2px solid #6c6c6c !important;
    }

    .selectAll {
        margin-right: 0.25rem; /* Tailwind: mr-1 */
        border: 1px solid #d1d5db; /* Tailwind: border-gray-300 */
        padding: 0.25rem 0.5rem; /* Tailwind: px-2 py-1 */
        border-radius: 0.375rem; /* Tailwind: rounded-md */
        background-color: white;
        color: #374151; /* Tailwind: text-gray-700 */
        font-size: 0.875rem; /* Tailwind: text-sm */
        transition: background-color 0.2s, color 0.2s; /* Tailwind: transition-colors duration-200 */
    }

    .selectAll:hover {
        background-color: #10b981; /* Tailwind: bg-emerald-500 */
        color: white;
    }
</style>